export enum PaperStatus {
  ALL_SET = 'ALL_SET',
  DRAFT = 'DRAFT',
  IN_REVIEW = 'IN_REVIEW',
}

export interface PaperType {
  title: string | null
  status?: PaperStatus | null
  paperId: string | null
}
